import { render, staticRenderFns } from "./RevisionLogsEditor.vue?vue&type=template&id=b5a52eb8&scoped=true"
import script from "./RevisionLogsEditor.vue?vue&type=script&lang=js"
export * from "./RevisionLogsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a52eb8",
  null
  
)

export default component.exports